import { useTooltip } from 'contexts/Tooltip/Tooltip';
import { CSSProperties, useEffect, useState } from 'react';

export default function TooltipContainer() {

    const [containerClasses, setContainerClasses] = useState('');
    const [containerStyles, setContainerStyles] = useState<CSSProperties>({});
    const [contentStyles, setContentStyles] = useState<CSSProperties>({});
    const tooltip = useTooltip();

    useEffect(() => {
        if (tooltip.open) {
            // Get app bounding rect
            const appRect = document?.querySelector('.calculator')?.getBoundingClientRect();

            if (appRect) {
                // Calculate position
                const left = Math.round(tooltip.x - appRect.left);
                const top = Math.round(tooltip.y - appRect.top);

                // Calculate spaces left and right
                const spaceRight = appRect.width - left;
                const spaceLeft = left - appRect.left;

                // Create new styles
                const newContentStyles: CSSProperties = {};
                const newContainerStyles: CSSProperties = {
                    left,
                    top
                };

                if (spaceRight >= 400) {
                    // Place right
                    setContainerClasses('right');
                    newContentStyles.width = Math.min(spaceRight, 600);
                } else if (spaceLeft >= 400) {
                    // Place Left
                    setContainerClasses('left');
                    newContentStyles.width = Math.min(spaceLeft, 600);
                } else {
                    // Place below
                    setContainerClasses('below');
                    newContentStyles.width = Math.min(appRect.width - 20, 600);
                    newContentStyles.left = Math.min(Math.max(-newContentStyles.width / 2, -left + 10), appRect.width - left - newContentStyles.width - 10);
                }

                // Update state
                setContainerStyles(newContainerStyles);
                setContentStyles(newContentStyles);
            }

        } else {
            setContainerClasses('');
            setContainerStyles({});
            setContentStyles({});
        }
    }, [
        tooltip.content,
        tooltip.open,
        tooltip.x,
        tooltip.y,
    ]);

    if (!tooltip.content || !tooltip.open) {
        return null;
    }

    return <div className={`tooltip-container ${containerClasses}`} style={containerStyles} onMouseLeave={tooltip.hide}>
        <div className="tooltip-content" style={contentStyles}>
            {tooltip.content}
        </div>
    </div>;

}